import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';

import { CartaoDaHistoriaNaMesa } from '@/historias/mesa';
import { ProvedorDeHistorias } from '@/historias/ProvedorDeHistorias';
import { clienteConsulta } from '@/lib/cliente-consulta';
import { roteador } from '@/rotas/rotas';

/**
 * Raiz da aplicacao: so a fiacao. Consulta por fora, roteamento por dentro —
 * assim qualquer rota pode usar `useQuery` sem provider proprio.
 *
 * O modo historias (manual p.44 a p.47) e o mesmo do celular: o provedor
 * guarda o interruptor e as conferencias, e o cartao flutua por cima de tudo.
 * Fora de homologacao, nada disso desenha.
 */
export function App() {
  return (
    <QueryClientProvider client={clienteConsulta}>
      <ProvedorDeHistorias>
        <RouterProvider router={roteador} />
        <CartaoDaHistoriaNaMesa />
      </ProvedorDeHistorias>
    </QueryClientProvider>
  );
}
